import React, { Component } from 'react'

import { Card } from '../../components/card'
import { Vehicle } from '../../core/types'

export interface Props {
  vehicle: Vehicle
}

export default class VehicleDetailsSpecs extends Component<Props> {
  static displayName = 'VehicleDetailsSpecs'

  render() {
    const { id, condition, colorExterior, healthReport, mileage, vin } =
      this.props.vehicle
    const specTitle = (
      <div>
        SPECIFICATIONS
        <a
          className="vehicle-details-specs__edit-link"
          href={`/vehicles/${id}/edit`}
        >
          Edit
        </a>
      </div>
    )

    return (
      <Card title={specTitle}>
        <div className="vehicle-details-specs">
          <section className="vehicle-details-specs__col">
            <div className="vehicle-details-specs__row">VIN</div>
            <div className="vehicle-details-specs__row">Mileage</div>
            <div className="vehicle-details-specs__row">Condition</div>
            <div className="vehicle-details-specs__row">Ext. Color</div>
            <div className="vehicle-details-specs__row">CARFAX</div>
          </section>
          <section className="vehicle-details-specs__col">
            <div className="vehicle-details-specs__row">{vin}</div>
            <div className="vehicle-details-specs__row">{mileage}</div>
            <div className="vehicle-details-specs__row">{condition}</div>
            <div className="vehicle-details-specs__row">{colorExterior}</div>
            {healthReport ? (
              <div className="vehicle-details-specs__row">
                <a href={`${healthReport.url}`} target="_blank">
                  View
                </a>
              </div>
            ) : (
              <div className="vehicle-details-specs__row">View</div>
            )}
          </section>
        </div>
      </Card>
    )
  }
}
